const AutoImportSources = {
    DocECM: 1,
    DocCapture: 2,
    DocDesktop: 3,
    DocLoader: 4,
    DocOfficeWord: 5,
    DocOfficeOutlook: 6,
    DocOfficePowerPoint: 7,
    DocOfficeExcel: 8,
    DocMobility: 9,
    DocImport: 10,
    DocCaptureService: 11,
    DocVPrinter: 12,
    OneDrive: 13,
    Email: 14,
    FileSystem: 15,
    DocOfficeOutlook365: 16,
    DocOfficeExcel365: 17,
    DocOfficeWord365: 18,
    DocOfficePowerPoint365: 19,
    EmailOffice365: 20,
    GoogleDrive: 22,
    External: 99,

    1: 'Doc.ECM',
    2: 'Doc.Capture',
    3: 'Doc.Desktop',
    4: 'Doc.Loader',
    5: 'Doc.Office Word',
    6: 'Doc.Office Outlook',
    7: 'Doc.Office PowerPoint',
    8: 'Doc.Office Excel',
    9: 'Doc.Mobility',
    10: 'Doc.Import',
    11: 'Doc.Capture.Service',
    12: 'Doc.VPrinter',
    15: 'File System',
    14: 'Email',
    13: 'OneDrive',
    16: 'Doc.Office Outlook365',
    17: 'Doc.Office Excel365',
    18: 'Doc.Office Word365',
    19: 'Doc.Office PowerPoint365',
    20: 'Email Office365',
    22: 'Google Drive',
    99: 'External',
};

export default AutoImportSources;
